import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    padding: '0',
    position: 'relative'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh'
  },
  header: {
    marginBottom: '2rem'
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '0.375rem',
    fontSize: '1.25rem'
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '0.875rem',
    lineHeight: 1.5
  },
  cardList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  cardListWithBar: {
    paddingBottom: '5rem'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000
  },
  loadingModal: {
    backgroundColor: 'white',
    padding: '2.5rem',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
  },
  loadingText: {
    fontSize: '1rem',
    fontWeight: 500,
    color: '#1a1d29'
  }
});

export default useStyles;
